/*
 * @Author: your name
 * @Date: 2021-04-16 09:07:37
 * @LastEditTime: 2021-04-16 09:26:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\router\modules\sales.js
 */
export default [
    {
      path: '/sales2',
      component: resolve => require(['../../views/sales2/index.vue'], resolve),
      meta: {
        title: '销售'
      }
    },
    {
        path: '/accountManagements',
        component: resolve => require(['../../views/sales2/accountManagement/accountManagement.vue'], resolve),
        meta: {
          title: '账户管理'
        }
      },
      {
        path: '/moneyMonitors_2',
        component: resolve => require(['../../views/sales2/moneyMonitor_2/moneyMonitor_2.vue'], resolve),
        meta: {
          title: '账户管理'
        }
      },
  ]


// WEBPACK FOOTER //
// ./src/TASMini/router/modules/sales.js